var _path, _mask, _path2, _path3, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCategoryWebsites(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 48,
    viewBox: "0 0 64 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 14H2V16V34C2 40.6274 7.37258 46 14 46H50C56.6274 46 62 40.6274 62 34V16V14H60H4Z",
    stroke: "currentColor",
    strokeWidth: 4
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-outside-1_1841_16854",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 64,
    height: 12,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    width: 64,
    height: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 12H60V12C60 7.58172 56.4183 4 52 4H12C7.58172 4 4 7.58172 4 12V12Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 12H60V12C60 7.58172 56.4183 4 52 4H12C7.58172 4 4 7.58172 4 12V12Z",
    fill: "currentColor",
    opacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 12H60H4ZM64 12C64 5.37258 58.6274 0 52 0H12C5.37258 0 0 5.37258 0 12H8C8 9.79086 9.79086 8 12 8H52C54.2091 8 56 9.79086 56 12H64ZM12 0C5.37258 0 0 5.37258 0 12H8C8 9.79086 9.79086 8 12 8V0ZM64 12C64 5.37258 58.6274 0 52 0V8C54.2091 8 56 9.79086 56 12H64Z",
    fill: "currentColor",
    mask: "url(#path-2-outside-1_1841_16854)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 8,
    r: 2,
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryWebsites);
export default __webpack_public_path__ + "react/media/category-websites.86978374ae5dfd69875af47a8e5148a1.svg";
export { ForwardRef as ReactComponent };